import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";

export default function Footer() {
  return (
    <FooterStyled className="bg-secondary bg-gradient text-center py-2 mt-4">
      <Container className="d-lg-flex align-items-center justify-content-center">
        <Nav className="flex-column flex-lg-row my-4 my-lg-0">
          <Nav.Link as={Link} to="/" className="text-white">
            Início
          </Nav.Link>
          <Nav.Link
            href="codigo-conduta-cifra.pdf"
            target="_blank"
            className="text-white"
          >
            Código de Conduta
          </Nav.Link>
        </Nav>
        <Nav className="justify-content-center">
          <Nav.Link
            href="https://www.linkedin.com/company/cifra-engenharia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white"
          >
            <IconStyled icon={faLinkedin} />
          </Nav.Link>
          <Nav.Link
            href="https://www.instagram.com/cifraengenharia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white"
          >
            <IconStyled icon={faInstagram} />
          </Nav.Link>
        </Nav>
      </Container>
    </FooterStyled>
  );
}

const FooterStyled = styled.footer`
  padding: 35px 0 40px;
  @media (min-width: 992px) {
    padding: 15px 0;
  }
`;

const IconStyled = styled(FontAwesomeIcon)`
  font-size: 40px;
`;
